/** Default space after paragraphs in the draft editor (Word-style pt). */
export const DEFAULT_PARAGRAPH_SPACING_PT = 12;

export const DEFAULT_LINE_SPACING = "1.5";
